import './page/riccardo-verbund-uebersicht/style.scss';

Shopware.Component.register('riccardo-verbund-uebersicht', () => import('./page/riccardo-verbund-uebersicht'));

Shopware.Module.register('riccardo-verbund', {
    type: 'plugin',
    name: 'riccardo-verbund',
    title: 'Systemzustand',
    description: 'Zustand der Frontends und Aufnahme weiterer Knoten',
    color: '#E30613',
    icon: 'regular-server',

    routes: {
        index: {
            component: 'riccardo-verbund-uebersicht',
            path: 'index',
            meta: { privilege: 'system.system_config' },
        },
    },

    navigation: [{
        id: 'riccardo-verbund',
        label: 'Systemzustand',
        color: '#E30613',
        path: 'riccardo.verbund.index',
        icon: 'regular-server',
        parent: 'sw-settings',
        position: 20,
        privilege: 'system.system_config',
    }],
});
